export enum NotificationType {
  CASE_UPDATES = 1,
  GENERAL_INFO = 2,
  CASE_MANAGEMENT = 3,
  ACTION_HISTORY = 4,
}

export interface ReqCaseUpdateHistoryFilterQuery {
  notificationType?: NotificationType
  keyword?: string
  startDate?: string
}

export interface ResCaseUpdateHistoryQuery {
  assignees: {
    count: number
    filterName: string
    filterValue: string
  }[]
}
